import { toDisplayString as _toDisplayString, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-df9c29ae")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("span", {
    class: ['c-tag', _ctx.active && 'c-tag--active' , _ctx.isDisabled && 'c-tag--disabled', _ctx.marginStyle],
    tabindex: _ctx.tabindex,
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click'))),
    onKeydown: [
      _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onEnterClick($event)), ["enter"])),
      _cache[3] || (_cache[3] = _withKeys(($event: any) => ($event.target.previousSibling.focus()), ["left"])),
      _cache[4] || (_cache[4] = _withKeys(($event: any) => ($event.target.nextElementSibling.focus()), ["right"]))
    ]
  }, _toDisplayString(_ctx.name), 43, ["tabindex"]))
})